<svelte:options accessors/>
<script>
    import {slide} from 'svelte/transition';
    import {createEventDispatcher} from 'svelte';
    import Button from './Button.svelte';
    import Spinner from './Spinner.svelte';

    const dispatch = createEventDispatcher();

    export let layout = 'text-accent';
    export let date = null;
    export let startDate = null;
    export let holidays = [];
    export let datePicker;
    export let maxDays = 0;
    export let limits = {};
    export let disabled = false;
    export let mode = 'regular'; // 'regular' or 'horizontal'
    // Лента (horizontal) разворачивается кликом по заголовку в обычный месячный вид:
    // так можно быстро уйти на несколько месяцев вперёд. Выбор дня сворачивает обратно.
    let expanded = false;
    // Оверлей развёрнутого вида: обёртка резервирует высоту свёрнутой ленты,
    // а панель рисуется поверх контента, не сдвигая форму вниз. Высота меряется
    // в момент разворота (getBoundingClientRect — с бордерами и дробями, иначе
    // контент дёргается на пиксель).
    let collapsedHeight;

    function expandCalendar() {
        collapsedHeight = el.getBoundingClientRect().height;
        expanded = true;
    }

    // Клик мимо развёрнутого календаря сворачивает его. Слушаем pointerdown:
    // он приходит до click и до перерендеров Svelte — с click реальный браузер
    // успевает удалить кликнутый заголовок из DOM (microtask checkpoint между
    // обработчиками всплытия), contains() даёт false и разворот тут же откатывался.
    function onWindowPointerDown(event) {
        if (expanded && el && ! el.contains(event.target)) {
            expanded = false;
            // Разворот мог быть в виде месяцев/годов — свёрнутая лента живёт
            // только в виде календаря.
            view = 'calendar';
        }
    }
    export let l10n = {};

    // Disabled week days array 0-Sunday, 6-Saturday
    export let disabledWeekDays = [];

    // Load schedule
    export let loadSchedule = false;

    $: displayMode = mode === 'horizontal' && ! expanded ? 'horizontal' : 'regular';

    let el;
    let rtl = false;

    $:if (el) {
        rtl = getComputedStyle(el).direction === 'rtl';
    }

    let bgColor, textColor, borderColor, buttonClasses, activeButtonClasses, disabledButtonClasses, otherMonthButtonClasses, controlButtonClasses;
    switch (layout) {
        case 'bg-accent':
            bgColor = 'bg-bookly';
            textColor = 'bookly:text-white';
            borderColor = 'border-bookly';
            buttonClasses = 'bookly:text-white bg-bookly:not-hover bookly:hover:bg-white hover:text-bookly';
            otherMonthButtonClasses = 'bookly:text-slate-300 bg-bookly:not-hover bookly:hover:bg-white hover:text-bookly';
            activeButtonClasses = 'bookly:bg-white text-bookly hover:text-bookly';
            disabledButtonClasses = '';
            controlButtonClasses = 'bookly:text-white bg-bookly:not-hover bookly:hover:bg-white hover:text-bookly';
            break;
        default:
            bgColor = 'bookly:bg-white';
            textColor = 'bookly:text-slate-600 bookly:hover:text-slate-600';
            borderColor = 'bookly:border-slate-100';
            buttonClasses = 'text-bookly hover:bg-bookly bookly:hover:text-white';
            otherMonthButtonClasses = 'bookly:text-slate-400 hover:bg-bookly bookly:hover:text-white';
            activeButtonClasses = 'bookly:text-white bg-bookly';
            disabledButtonClasses = 'bookly:bg-slate-100';
            controlButtonClasses = 'bookly:text-slate-600 hover:bg-bookly bookly:hover:text-white';
            break;
    }

    export function forceLoadSchedule() {
        holidays = [];
        loadedMonths = [];
        loading = true;
    }

    $: if (startDate === null) {
        startDate = new Date();
    } else {
        year = startDate.getFullYear();
        month = startDate.getMonth();
    }

    if (maxDays) {
        limits.end = new Date();
        limits.end.setDate(limits.end.getDate() + parseInt(maxDays));
    }


    let view = 'calendar';
    let start = date ? new Date(date) : new Date();
    export let year = start.getFullYear();
    export let month = start.getMonth();
    let title = '';
    let days = [];

    let currentWeek = -1; // force to calculate current week on first render

    export let loadedMonths = [];
    export let loading = true;

    export let show = true;
    export let border = false;

    function changeView() {
        switch (view) {
            case 'calendar':
                view = 'month';
                break;
            case 'month':
                view = 'year';
                break;
            case 'year':
                view = 'calendar';
                break;
        }
    }

    function onClickLeft() {
        if (displayMode === 'horizontal' && currentWeek > 0) {
            currentWeek--;
            return;
        }
        switch (view) {
            case 'calendar':
                if (month === 0) {
                    month = 11;
                    year--;
                } else {
                    month--;
                }
                currentWeek = 999; // force to show last week
                dispatch('month-change', 'prev');
                break;
            case 'month':
                year--;
                break;
            case 'year':
                year -= 9;
                break;
        }
    }

    function onClickRight() {
        if (displayMode === 'horizontal' && currentWeek < parseInt(days.length / 7) - 1) {
            currentWeek++;
            return;
        }
        switch (view) {
            case 'calendar':
                if (month === 11) {
                    month = 0;
                    year++;
                } else {
                    month++;
                }
                currentWeek = days[days.length - 1].title < 7 ? 1 : 0;
                dispatch('month-change', 'next');
                break;
            case 'month':
                year++;
                break;
            case 'year':
                year += 9;
                break;
        }
    }

    let monthWithYear;

    $: monthWithYear = month + '-' + year;

    let lastDate = monthWithYear;

    $: if (loadSchedule !== false && view === 'calendar' && (year || month)) {
        if (lastDate !== monthWithYear) {
            lastDate = monthWithYear;
            loading = true;
        }
    }

    $: if (loadSchedule !== false && loading) {
        _loadSchedule();
    }

    function _loadSchedule() {
        if (!loadedMonths.includes(monthWithYear)) {
            // The no-date fallback below moves month/year to the first bookable
            // day. Apply it only if the view still shows the requested month:
            // a late response must not override the user's navigation.
            let requestedMonth = month,
                requestedYear = year;
            loadSchedule(month + 1, year)
                .then(response => {
                    loadedMonths = [...new Set([...loadedMonths, ...(response?.data.parsed_months || [])])];

                    holidays = [...new Set([...holidays, ...(response?.data.holidays || [])])];
                    if (date === null && month === requestedMonth && year === requestedYear) {
                        let firstDate = new Date();
                        while (holidays.includes(date = formatDate(firstDate))) {
                            firstDate.setDate(firstDate.getDate() + 1);
                        }
                        date = formatDate(firstDate);
                        month = firstDate.getMonth();
                        year = firstDate.getFullYear();
                        dispatch('change');
                    }
                }).catch(() => {
                if (date === null && month === requestedMonth && year === requestedYear) {
                    let firstDate = new Date();
                    date = formatDate(firstDate);
                    month = firstDate.getMonth();
                    year = firstDate.getFullYear();
                    dispatch('change');
                }
            })
                .finally(() => loading = false);
        } else {
            loading = false;
        }
    }

    function onClickDate(_day) {
        document.activeElement && document.activeElement.blur();
        expanded = false;
        month = _day.date.getMonth();
        year = _day.date.getFullYear();
        date = formatDate(_day.date);
        currentWeek = -1;
        dispatch('change');
    }

    function formatDate(day) {
        let _month = day.getMonth() + 1,
            _day = day.getDate(),
            _year = day.getFullYear();

        return _year + '-' + (_month < 10 ? '0' + _month : _month) + '-' + (_day < 10 ? '0' + _day : _day);
    }

    $: {
        let _day = new Date(year, month, 1);

        _day.setDate(_day.getDate() - ((((_day.getDay() - datePicker.firstDay) % 7) + 7) % 7));
        let lastDay = new Date(year, month + 1, 0);
        lastDay.setDate(lastDay.getDate() - ((((lastDay.getDay() - datePicker.firstDay) % 7) + 7) % 7) + 6);
        days = [];
        do {
            let dayFormatted = formatDate(_day);
            days.push({
                'title': _day.getDate(),
                'current': _day.getMonth() === month,
                'disabled': (limits && limits.hasOwnProperty('start') && _day < limits.start) || (limits && limits.hasOwnProperty('end') && _day > limits.end) || disabledWeekDays.includes(_day.getDay()) || (loadedMonths.includes(monthWithYear) && holidays.includes(dayFormatted)),
                'active': date === dayFormatted,
                'date': new Date(_day.getTime())
            });
            _day.setDate(_day.getDate() + 1);
        } while (lastDay >= _day);
    }

    $: if (displayMode === 'horizontal') {
        if (currentWeek === -1 && days.length > 0) {
            days.forEach((day, index) => {
                if (day.active) {
                    currentWeek = parseInt(index / 7);
                }
            });
        } else if (currentWeek === 999) {
            currentWeek = parseInt(days.length / 7) - (days[days.length - 1].title < 7 ? 2 : 1);
        }
    }

    $: if (view) {
        switch (view) {
            case 'calendar':
                title = datePicker.monthNamesShort[month] + ' ' + year;
                break;
            case 'month':
            case 'year':
                title = year;
                break;
        }
    }
</script>
<style lang="scss">
    .bookly-calendar-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.1);
        z-index: 2;
        cursor: wait;
    }
</style>
<svelte:window on:pointerdown={onWindowPointerDown}/>
{#if show}
    <div class="{mode === 'horizontal' ? 'bookly:relative bookly:w-full' : 'bookly:contents'}" style="{mode === 'horizontal' && expanded && collapsedHeight ? 'height:' + collapsedHeight + 'px' : ''}">
    <div class="bookly-panel-mark bookly:w-full bookly:max-w-lg bookly:min-h-full bookly:p-0.5 {bgColor} {borderColor} bookly:rounded {border ? 'bookly:border bookly:p-0.5 bookly:rounded' : ''} {mode === 'horizontal' ? 'bookly:mx-auto' : ''} {mode === 'horizontal' && expanded ? 'bookly:absolute bookly:top-0 bookly:left-1/2 bookly:-translate-x-1/2 bookly:z-30 bookly:shadow-xl' : 'bookly:relative'}" bind:this={el} in:slide={{ duration: 200 }}>
        {#if loading || disabled}
            <div class="bookly-calendar-overlay">
            </div>
        {/if}
        {#if displayMode !== 'horizontal'}
            <div class="bookly:w-full bookly:border-b {borderColor} bookly:mb-0.5 bookly:pb-0.5 bookly-calendar-controls-mark">
                <div class="bookly:flex bookly:text-gray-400 bookly:max-w-96 bookly:m-auto" role="group">
                    <Button
                            class="bookly:grow-0 bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly-calendar-left-button-mark bookly:m-0 bookly:px-4 bookly:text-xl bookly:shadow-none bookly:cursor-pointer {controlButtonClasses}"
                            type="calendar"
                            bordered={false}
                            rounded={false}
                            margins={false}
                            disabled={loading || (limits && limits.hasOwnProperty('start') && month <= limits.start.getMonth() && year === limits.start.getFullYear())}
                            on:click={onClickLeft}
                            on:keypress={onClickLeft}
                            container="div"
                            ariaLabel={l10n.prev}
                    >
                        <i class="bi" class:bi-chevron-left={!rtl} class:bi-chevron-right={rtl}></i>
                    </Button>
                    <Button
                            class="bookly:grow bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly-calendar-middle-button-mark bookly:m-0 bookly:text-lg bookly:shadow-none bookly:cursor-pointer {controlButtonClasses}"
                            type="calendar"
                            bordered={false}
                            rounded={false}
                            margins={false}
                            on:click={changeView}
                            on:keypress={changeView}
                            container="div"
                    >
                        {title}
                    </Button>
                    <Button
                            class="bookly:grow-0 bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly-calendar-right-button-mark bookly:m-0 bookly:px-4 bookly:text-xl bookly:shadow-none bookly:cursor-pointer {controlButtonClasses}"
                            type="calendar"
                            bordered={false}
                            rounded={false}
                            margins={false}
                            disabled={loading || (limits && limits.hasOwnProperty('end') && month >= limits.end.getMonth() && year === limits.end.getFullYear())}
                            on:click={onClickRight}
                            on:keypress={onClickRight}
                            container="div"
                            ariaLabel={l10n.next}
                    ><i class="bi" class:bi-chevron-left={rtl} class:bi-chevron-right={!rtl}></i></Button>
                </div>
            </div>
        {/if}
        <div class="bookly:w-full">
            {#if view === 'calendar'}
                <div class="bookly:w-full bookly-calendar-dates-mark" transition:slide={{ duration: mode === 'horizontal' ? 0 : 400 }}>
                    {#if displayMode === 'horizontal'}
                        <div class="bookly:text-base bookly:text-center bookly:border-b {borderColor} {textColor} bookly:mb-1 bookly:cursor-pointer bookly-calendar-title-mark"
                             role="button"
                             tabindex="0"
                             on:click={expandCalendar}
                             on:keypress={expandCalendar}
                        >
                            {title} <i class="bi bi-chevron-down bookly:text-xs"></i>
                        </div>
                    {:else}
                        <div class="bookly:flex bookly:flex-row fw-bold bookly:text-center bookly:text-muted bookly:w-full bookly:border-b {borderColor} bookly:mb-0.5 bookly:py-2 bookly:max-w-full">
                            {#each {length: 7} as _, i}
                                <div class="bookly:flex-1 bookly:px-0 bookly:overflow-hidden bookly:text-sm {textColor} bookly:cursor-default">{datePicker.dayNamesShort[(i + datePicker.firstDay) % 7]}</div>
                            {/each}
                        </div>
                    {/if}
                    <div class="bookly:relative bookly:rounded">
                        {#each {length: parseInt(days.length / 7)} as _, i}
                            {#if displayMode !== 'horizontal' || i === currentWeek}
                                <div class="bookly:flex bookly:w-full">
                                    {#if displayMode === 'horizontal'}
                                        <Button
                                                class="{ displayMode === 'horizontal' ? 'bookly:py-2 bookly:px-1 bookly:rounded bookly:md:mx-1 bookly:h-12 bookly:text-lg bookly:md:px-4' : 'bookly:px-4'} bookly:grow-0 bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly-calendar-left-button-mark bookly:m-0 bookly:text-xl bookly:shadow-none bookly:cursor-pointer {controlButtonClasses}"
                                                type="calendar"
                                                bordered={false}
                                                rounded={displayMode === 'horizontal'}
                                                margins={false}
                                                disabled={loading || (limits && limits.hasOwnProperty('start') && month <= limits.start.getMonth() && year === limits.start.getFullYear() && (displayMode !== 'horizontal' || currentWeek <= 0))}
                                                on:click={onClickLeft}
                                                on:keypress={onClickLeft}
                                                container="div"
                                        >
                                            <i class="bi" class:bi-chevron-left={!rtl} class:bi-chevron-right={rtl}></i>
                                        </Button>
                                    {/if}
                                    {#each {length: 7} as _, j}
                                        {@const _day = days[i * 7 + j]}
                                        {@const _disabled = _day.disabled}
                                        <Button
                                                type='calendar'
                                                class="{ displayMode === 'horizontal' ? 'bookly:py-2 bookly:px-1 bookly:rounded bookly:md:mx-1 bookly:h-12' : 'bookly:h-10'} bookly:leading-4 bookly:shadow-none bookly:flex-1 bookly:py-2 bookly:px-0 bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:cursor-pointer {_disabled ? disabledButtonClasses : ''} {_day.active ? activeButtonClasses : (_day.current ? buttonClasses : otherMonthButtonClasses)} {_day.current ? 'bookly-calendar-current-month-mark' : ''}"
                                                bordered={false}
                                                on:click={() => !_disabled && onClickDate(_day)}
                                                on:keypress={() => !_disabled && onClickDate(_day)}
                                                disabled={_disabled}
                                                container="div"
                                                size="custom"
                                        >
                                            {#if displayMode === 'horizontal'}
                                                <span class="bookly:text-xs">
                                                {datePicker.dayNamesShort[(j + datePicker.firstDay) % 7]}
                                                </span><br/>
                                            {/if}
                                            <span
                                                    class:bookly:text-lg={displayMode === 'horizontal'}
                                                    class:bookly:text-sm={displayMode !== 'horizontal'}
                                            >
                                            {_day.title}
                                            </span>
                                        </Button>
                                    {/each}
                                    {#if displayMode === 'horizontal'}
                                        <Button
                                                class="{ displayMode === 'horizontal' ? 'bookly:py-2 bookly:px-1 bookly:rounded bookly:md:mx-1 bookly:h-12 bookly:text-lg bookly:md:px-4' : 'bookly:px-4'} bookly:grow-0 bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly-calendar-right-button-mark bookly:m-0 bookly:text-xl bookly:shadow-none bookly:cursor-pointer {controlButtonClasses}"
                                                type="calendar"
                                                bordered={false}
                                                rounded={displayMode === 'horizontal'}
                                                margins={false}
                                                disabled={loading || (limits && limits.hasOwnProperty('end') && month >= limits.end.getMonth() && year === limits.end.getFullYear())}
                                                on:click={onClickRight}
                                                on:keypress={onClickRight}
                                                container="div"
                                        ><i class="bi" class:bi-chevron-left={rtl} class:bi-chevron-right={!rtl}></i></Button>
                                    {/if}
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>
            {:else if view === 'month'}
                <div class="bookly:w-full bookly:text-center bookly:grid bookly:grid-cols-4 bookly-calendar-months-mark" transition:slide={{ duration: mode === 'horizontal' ? 0 : 400 }}>
                    {#each {length: 12} as _,_month}
                        {@const _date = new Date(year, _month + 1, 0)}
                        {@const _end_date = new Date(year, _month, 1)}
                        {@const _disabled = limits && ((limits.hasOwnProperty('start') && limits.start > _date) || (limits.hasOwnProperty('end') && limits.end < _end_date))}
                        <div>
                            <Button
                                    type="calendar"
                                    class="bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly:px-2 bookly:py-0 bookly:m-0 bookly:text-xl bookly:h-16 bookly:cursor-pointer {_disabled ? disabledButtonClasses : ''} {buttonClasses}"
                                    bordered={false}
                                    rounded={false}
                                    margins={false}
                                    paddings={false}
                                    on:click={() => {month = _month; dispatch('month-change'); view='calendar'}}
                                    on:keypress={() => {month = _month; dispatch('month-change'); view='calendar'}}
                                    disabled={_disabled}
                                    container="div"
                                    size="custom"
                            >
                                {datePicker.monthNamesShort[_month]}
                            </Button>
                        </div>
                    {/each}
                </div>
            {:else}
                <div class="bookly:w-full bookly:text-center bookly:grid bookly:grid-cols-3 bookly-calendar-years-mark" transition:slide={{ duration: mode === 'horizontal' ? 0 : 400 }}>
                    {#each {length: 9} as _,_year}
                        {@const __year = year + _year - 4}
                        {@const _date = new Date(__year, 12, 0)}
                        {@const _disabled = limits && ((limits.hasOwnProperty('start') && limits.start.getFullYear() > _date.getFullYear()) || (limits.hasOwnProperty('end') && limits.end.getFullYear() < _date.getFullYear()))}
                        <div class="col-4">
                            <Button
                                    type="calendar"
                                    bordered={false}
                                    rounded={false}
                                    paddings={false}
                                    margins={false}
                                    class="bookly:border-none bookly:focus:border-none bookly:focus:outline-none bookly:leading-normal bookly:px-2 bookly:py-0 bookly:m-0 bookly:text-xl bookly:h-16 bookly:cursor-pointer {_disabled ? disabledButtonClasses : ''} {buttonClasses}"
                                    on:click={() => {year = __year; view='month'}}
                                    on:keypress={() => {year = __year; view='month'}}
                                    disabled={_disabled}
                                    container="div"
                                    size="custom"
                            >
                                {__year}
                            </Button>
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
    </div>
    </div>
{/if}